(function () {
  var SECTION_SELECTOR = '.oddit-section-traits-band';
  var sectionState = new Map();

  function initMarquee(section) {
    var track = section.querySelector('[data-marquee-track]');
    var firstSet = section.querySelector('[data-marquee-set]');
    if (!track || !firstSet) return null;

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function measure() {
      var setWidth = firstSet.scrollWidth;
      var trackStyle = getComputedStyle(track);
      var trackGap = parseFloat(trackStyle.columnGap) || parseFloat(trackStyle.gap) || 0;
      var distance = setWidth + trackGap;
      track.style.setProperty('--marquee-distance', '-' + distance + 'px');
    }

    function enable() {
      measure();
      track.style.animationPlayState = 'running';
    }

    function disable() {
      track.style.animationPlayState = 'paused';
    }

    if (reducedMotion.matches) {
      disable();
    } else {
      enable();
    }

    var ro = new ResizeObserver(function () {
      if (!reducedMotion.matches) measure();
    });
    ro.observe(section);

    function onMotionChange(e) {
      if (e.matches) {
        disable();
      } else {
        enable();
      }
    }
    reducedMotion.addEventListener('change', onMotionChange);

    function onVisibility() {
      if (reducedMotion.matches) return;
      track.style.animationPlayState = document.hidden ? 'paused' : 'running';
    }
    document.addEventListener('visibilitychange', onVisibility);

    return {
      destroy: function () {
        ro.disconnect();
        reducedMotion.removeEventListener('change', onMotionChange);
        document.removeEventListener('visibilitychange', onVisibility);
      }
    };
  }

  function initSection(section) {
    if (sectionState.has(section)) return;
    sectionState.set(section, { marquee: initMarquee(section) });
  }

  function destroySection(section) {
    var state = sectionState.get(section);
    if (!state) return;
    if (state.marquee) state.marquee.destroy();
    sectionState.delete(section);
  }

  document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) destroySection(section);
  });
})();
